import { Component, OnInit } from "@angular/core";
import { ModelService } from "../Services/model.service";
import { TranslateService } from "@ngx-translate/core";
import { Template } from "../Model/Catalog/Template";
import { Message } from "../Model/System/Message";
import { TemplateService } from "../Services/template.service";
import { lastValueFrom } from "rxjs";


@Component({
  selector: "templateList",
  templateUrl: "templateList.component.html",
  styleUrls: ["./templateList.component.css"]
})
export class TemplateListComponent implements OnInit {

  exportMode: boolean = false;
  editorVisible: boolean = false;
  public canAddTemplate: boolean = false;

  txtDuplikat: string = null;

  constructor(public modelService: ModelService, public templateService: TemplateService, public translate: TranslateService) {
    this.getAddTemplateHint = this.getAddTemplateHint.bind(this);

  }

  async ngOnInit() {
    if (this.modelService.loginService.currentUser == null) {
      this.modelService.router.navigate(["/"]);
      return;
    }

    if (this.modelService.router.url === '/templates') {
      this.translate.get('Excel Templates').subscribe((text: string) => {
        this.modelService.systemService.currentNavigationTitle = text;
      });
    }

    this.templateService.getTemplates();

    this.txtDuplikat = this.translate.instant('Duplikat');

    this.canAddTemplate = await lastValueFrom(this.templateService.canCustomerAddTemplate(this.modelService.loginService.currentCustomer.id));
  }

  public onLogoClicked() {
    this.modelService.router.navigate(["/catalogs"]);
  }



  get templates(): Template[] {
    return this.templateService.templates;
  }



  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'newTemplateButtonTemplate'
    });
    e.toolbarOptions.items.unshift({
      location: 'after',
      locateInMenu: 'auto',
      template: 'helpButtonTemplate'
    });
  }



  public addTemplateVisible = false;
  showAddTemplate() {
    this.addTemplateVisible = true;
  }



  async addTemplate(e) {
    this.addTemplateVisible = false;

    let newTemplate = new Template();               // data würde an sich auch gehen... vllt., ABER der CTOR initialisiert noch ein bissel was...
    newTemplate.lastChange = newTemplate.created;   // Wird nicht vom CTOR gesetzt
    newTemplate.isExportTemplate = true;

    newTemplate.name = e;

    await this.templateService.addTemplate(newTemplate);
    this.canAddTemplate = await lastValueFrom(this.templateService.canCustomerAddTemplate(this.modelService.loginService.currentCustomer.id));
  }

  getAddTemplateHint() {
    if (this.canAddTemplate)
      return null;

    return this.translate.instant("In ihrer Lizenz dürfen Sie keine Templates mehr anlegen.");
  }

  rowUpdated(e) {
    let template = e.data as Template;

    template.lastChange = new Date();

    this.templateService.saveTemplate(template, true);
  }

  async rowRemoved(e) {
    let template = e.data as Template;

    await this.templateService.deleteTemplate(template);

    e.cancel = true;

    this.canAddTemplate = await lastValueFrom(this.templateService.canCustomerAddTemplate(this.modelService.loginService.currentCustomer.id));
  }



  async duplicateTemplate(e) {
    if (!this.canAddTemplate) {
      this.modelService.systemService.notifyWarning(this.translate.instant("In ihrer Lizenz dürfen Sie keine Templates mehr anlegen."));
      return;
    }

    let templatetemplate = e.data as Template;

    let copiedTemplate = new Template();     // data würde an sich auch gehen... vllt., ABER der CTOR initialisiert noch ein bissel was...
    copiedTemplate.lastChange = copiedTemplate.created;   // Wird nicht vom CTOR gesetzt
    copiedTemplate.isExportTemplate = templatetemplate.isExportTemplate;

    copiedTemplate.customerId = templatetemplate.customerId;
    copiedTemplate.name = templatetemplate.name + " - " + this.txtDuplikat;
    copiedTemplate.remarks = templatetemplate.remarks;
    copiedTemplate.isUseable = templatetemplate.isUseable;
    copiedTemplate.templateItems = templatetemplate.templateItems;

    await this.templateService.addTemplate(copiedTemplate);

    this.canAddTemplate = await lastValueFrom(this.templateService.canCustomerAddTemplate(this.modelService.loginService.currentCustomer.id));
  }

  editTemplate(e) {
    let template = e.data as Template;
    this.editorVisible = true;
    this.templateService.template = template;

    this.exportMode = template.isExportTemplate;

  }
}
